import { render, staticRenderFns } from "./NewGridItem.vue?vue&type=template&id=c05a6098&"
import script from "./NewGridItem.vue?vue&type=script&lang=js&"
export * from "./NewGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports